class ShippingCalculator extends HTMLElement {
  constructor() {
    super();
    this.eraseCookie("validCep");
    this.cepInput = this.querySelector("#cep-input");
    this.message = this.querySelector("#cep-message");
    this.shippingPriceValue = document.querySelector(
      "#cart-footer-shipping-price"
    );
    this.validateBtn = this.querySelector("#validate-cep-btn");
    this.handleValidation = this.handleValidation.bind(this);
    this.validateBtn.addEventListener("click", this.handleValidation);
  }

  connectedCallback() {
    this.waitForElement("#checkout", (checkoutBtn) => {
      this.checkoutBtn = checkoutBtn;
      this.setupCheckoutButton();
    });
    if (this.cepInput) {
      this.cepInput.addEventListener("input", (event) => {
        this.applyCepMask(event.target);
      });
    }
    if (this.getCookie("validCep") === "true") {
      this.checkoutBtn.disabled = false;
    }
  }

  waitForElement(selector, callback) {
    const interval = setInterval(() => {
      const element = document.querySelector(selector);
      if (element) {
        clearInterval(interval);
        callback(element);
      }
    }, 100);
  }

  setupCheckoutButton() {
    this.checkoutBtn.disabled = true;
    this.checkoutBtn.style.display = "block";
    if (this.getCookie("validCep") === "true") {
      this.checkoutBtn.disabled = false;
    }
  }

  setCookie(name, value, minutes) {
    const date = new Date();
    date.setTime(date.getTime() + minutes * 60 * 1000);
    const expires = "; expires=" + date.toUTCString();
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

  getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(";");
    for (let c of ca) {
      while (c.charAt(0) === " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  eraseCookie(name) {
    document.cookie = name + "=; Max-Age=-99999999;";
  }

  applyCepMask(input) {
    input.value = window.PapaPetsShipping.formatCep(input.value);
  }

  async fetchCartItems() {
    const response = await fetch("/cart.js");
    const cart = await response.json();
    return cart.items || [];
  }

  bucketItemsByProductType(items) {
    const { PRODUCT_TYPES } = window.PapaPetsShipping;
    return {
      flatItems: items.filter((item) => item.product_type === PRODUCT_TYPES.FLAT),
      restrictedItems: items.filter(
        (item) => item.product_type === PRODUCT_TYPES.RESTRICTED
      ),
    };
  }

  showValidDisplay({ hasFlat, hasRestricted, tier, total }) {
    const rates = window.PapaPetsShipping;
    this.message.classList.add("success");
    this.message.classList.remove("error");

    let text;
    if (hasFlat && hasRestricted) {
      text = `Entrega para ${tier.city}: Latas/petiscos ${rates.formatMoney(
        rates.FLAT_RATE.price
      )} (${rates.FLAT_RATE.days}) + Dietas/congelados ${rates.formatMoney(
        tier.price
      )} (${tier.days}) = ${rates.formatMoney(total)}`;
    } else if (hasRestricted) {
      text = `Entrega para ${tier.city} - ${rates.formatMoney(tier.price)} | ${tier.days}`;
    } else {
      text = `Entrega para todo o Brasil - ${rates.formatMoney(
        rates.FLAT_RATE.price
      )} | ${rates.FLAT_RATE.days}`;
    }

    this.message.innerHTML = text;
    this.shippingPriceValue.textContent = rates.formatMoney(total);
    this.checkoutBtn.disabled = false;
    this.setCookie("validCep", "true", 15);
  }

  showInvalidDisplay(message) {
    this.message.innerHTML =
      message || "Infelizmente, não podemos entregar para essa região.";

    this.message.classList.remove("success");
    this.message.classList.add("error");

    this.shippingPriceValue.textContent = "Calcule acima";
    this.checkoutBtn.disabled = true;
    this.eraseCookie("validCep");
  }

  async handleValidation() {
    const rates = window.PapaPetsShipping;
    const cep = rates.formatCep(this.cepInput.value);

    if (!rates.isCompleteCep(cep)) {
      this.showInvalidDisplay("Digite um CEP válido.");
      return;
    }

    this.validateBtn.disabled = true;
    try {
      const items = await this.fetchCartItems();
      const { flatItems, restrictedItems } = this.bucketItemsByProductType(items);
      const hasFlat = flatItems.length > 0;
      const hasRestricted = restrictedItems.length > 0;

      if (!hasFlat && !hasRestricted) {
        this.showInvalidDisplay("Adicione produtos ao carrinho para calcular o frete.");
        return;
      }

      let total = 0;
      let tier = null;

      if (hasFlat) {
        total += rates.FLAT_RATE.price;
      }

      if (hasRestricted) {
        tier = rates.findCepTier(cep);
        if (!tier) {
          this.showInvalidDisplay(
            "Infelizmente, não podemos entregar dietas/congelados para essa região."
          );
          return;
        }
        total += tier.price;
      }

      this.showValidDisplay({ hasFlat, hasRestricted, tier, total });
    } finally {
      this.validateBtn.disabled = false;
    }
  }
}

customElements.define("shipping-calculator", ShippingCalculator);
